var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWearableDeviceFilled = function SvgWearableDeviceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.617 2.108a1.044 1.044 0 0 0-1.025-.858H8.408c-.5 0-.933.358-1.025.858L7.2 3.125h5.6l-.183-1.017ZM7.383 17.892c.092.5.525.858 1.025.858h3.184c.5 0 .933-.358 1.025-.858l.183-1.017H7.2l.183 1.017ZM6.667 4.375h6.666a2.29 2.29 0 0 1 2.292 2.292v6.666a2.29 2.29 0 0 1-2.292 2.292H6.667a2.29 2.29 0 0 1-2.292-2.292V6.667a2.29 2.29 0 0 1 2.292-2.292Zm3.525 8.083 2.091-2.091a1.469 1.469 0 0 0-.025-2.092c-.583-.558-1.516-.517-2.083.058L10 8.508l-.175-.175c-.567-.575-1.5-.616-2.083-.058a1.469 1.469 0 0 0-.025 2.092l2.091 2.091a.267.267 0 0 0 .384 0Z",
    fill: "current"
  })));
};
export default SvgWearableDeviceFilled;